import PropTypes from 'prop-types';

export const themePropType = PropTypes.oneOf(['light', 'dark']).isRequired;
export const imageArrayPropType = PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string, //for image paths
      PropTypes.shape({ //for more complex image objects
        src: PropTypes.string.isRequired,
        alt: PropTypes.string,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      })
    ])
  ).isRequired;